/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_OnlineInputs */



/**
* | output |
* | --- |
* | "Online" |
*
* @param {Tournaments_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_online = /** @type {((inputs?: Tournaments_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("En línea")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Online")
	if (locale === "it") return /** @type {LocalizedString} */ ("Online")
	return /** @type {LocalizedString} */ ("Online")
});